import React from "react";
import "../css/dashboard.css";
import DashboardContent from "./DashboardContent";
import Navbar from "../component/Navbar";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardContentMobile from "./DashboardContentMobile";

export default function Dashboard() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <DashboardContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={6} />
          <DashboardContent />
        </>
      )}
    </div>
  );
}
